(function () {
    'use strict';
    angular.module('app.errorHandler', [])
      .constant('httpErrors', {
          0: 'The server is unreachable.',
          404: 'The requested data or service could not be found.',
          500: 'Unknown errors occurred at the server.'
      })
      .provider('errorHandler', function () {

          // Wrap a single function [func] in another function that handles both synchronous and asynchonous errors.
          function decorate($injector, obj, func) {
              return angular.extend(function () {
                  var handler = $injector.get('errorHandler');
                  return handler.call(func, obj, arguments);
              }, func);
          }

          // Decorate all functions of the service [$delegate] with error handling. This function should be used as decorator
          // function in a call to $provide.decorator().
          var decorator = ['$delegate', '$injector', '$filter', function ($delegate, $injector, $filter) {
              // Loop over all functions in $delegate and wrap these functions using the [decorate] functions above.
              for (var prop in $delegate) {
                  if (angular.isFunction($delegate[prop])) {
                      $delegate[prop] = decorate($injector, $delegate, $delegate[prop]);
                  }
              }
              return $delegate;
          }];

          // The actual service:
          return {
              // Decorate the mentioned [services] with automatic error handling.
              decorate: function ($provide, services) {
                  angular.forEach(services, function (service) {
                      $provide.decorator(service, decorator);
                  });
              },

              $get: function ($log, httpErrors, $filter) {

                  var handler = {

                      // The list of errors.
                      errors: [],


                      // Report the error [err] in relation to the function [func].
                      funcError: function (func, err, eee) {

                          if (err && err.data.constructor === Blob) {
                              var reader = new FileReader();

                              // This fires after the blob has been read/loaded.
                              reader.addEventListener('loadend', function (e) {
                                  var errorObj = JSON.parse(e.srcElement.result);
                                  var error = { status: 500, message: errorObj.Message };
                                  handler.errors.push({ message: error, type: 1, title: "Error" });
                              });

                              // Start reading the blob as text.
                              reader.readAsText(err.data);
                          }
                          else {

                              // This is a very limited error handler... you would probably want to check for user-friendly error messages
                              // that were returned by the server, etc, etc, etc. Our original code contains a lot of checks and handling
                              // of error messages to create the "perfect" error message for our users, you should probably do the same. :)
                              var title = "Error";
                              if (err && !angular.isUndefined(err.status)) {
                                  var message;
                                  // A lot of errors occur in relation to HTTP calls... translate these into user-friendly msgs.
                                  if (err.data) {
                                      if (err.data.ExceptionMessage) {
                                          message = err.data.ExceptionMessage;
                                          title = err.data.ExceptionType;
                                      }
                                      else {
                                          if (err.data.Message) {
                                              message = err.data.Message;
                                          }
                                          else if (err.data.error_description) {
                                              message = err.data.error_description;
                                          }
                                          else {
                                              message = httpErrors[err.status];
                                          }
                                      }

                                  }

                              } else if (err && err.message) {
                                  // Exceptions are unwrapped.
                                  message = err.message;
                              }
                              if (!angular.isString(err)) {
                                  //message = 'An unknown error occurred.';
                              }

                              // Use the context provided by the service.
                              if (func && func.description) {
                                  //message = 'Unable to ' + func.description + '. ' + err;
                              }

                              //$log.info('Caught error: ' + err);
                              var type1s = $filter("filter")(handler.errors, { type: 1 });
                              if (type1s.length == 0) {
                                  handler.errors = [];
                              }
                              if (error) {
                                  var error = { url: err.config.url, status: err.status, message: message };
                                  handler.errors.push({ message: error, type: 0 });
                              }
                              //ignore the user is already logged in message
                              if (err) {
                                  if (err.data && err.data.error != 'user_loggedin') {
                                      //ignore refresh token invalid grants
                                      if (err.data.error == "invalid_grant" && !err.data.error_description) {
                                          return;
                                      }
                                      else {
                                          if (err.data.error == "license_error") {
                                              handler.errors.push({ message: message, type: 1, title: title });
                                          }
                                          else {
                                              if (!message) {
                                                  try {
                                                      message = $($(err.data)[5]).html();
                                                  } catch (e) {

                                                  }
                                              }
                                              handler.errors.push({ message: message, type: 0, title: title });
                                          }
                                      }

                                  }
                              }

                          }


                          
                      },


                      // Call the provided function [func] with the provided [args] and error handling enabled.
                      call: function (func, self, args) {
                          //$log.debug('Function called: ', (func.name || func));

                          var result;
                          try {
                              result = func.apply(self, args);
                          } catch (err) {
                              // Catch synchronous errors.
                              handler.funcError(func, err);
                              throw err;
                          }

                          // Catch asynchronous errors.
                          var promise = result && result.$promise || result;
                          if (promise && angular.isFunction(promise.then) && angular.isFunction(promise['catch'])) {
                              // promise is a genuine promise, so we call [handler.async].
                              handler.async(func, promise);
                          }

                          return result;
                      },


                      // Automatically record rejections of the provided [promise].
                      async: function (func, promise) {
                          promise['catch'](function (err) {
                              handler.funcError(func, err);
                          });
                          return promise;
                      }
                  };

                  return handler;
              }
          };
      });
})();